import React from 'react';

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const ModalContainer = ({ show, title, close, children, idForm }) => {

    const dialogFooter = (
        <div>
            <Button size='small' severity='secondary' label="Cancelar" className="p-button-raised" onClick={close} />
            <Button size='small' type='submit' form={idForm} label="Guardar" severity='success' className="p-button-raised" />
        </div>
    );

    return (
        <Dialog visible={show} 
        header={title} 
        modal 
        className="p-fluid custom-modal-width" 
        footer={<div style={{ paddingTop:"1rem"}}>{dialogFooter}</div>} 
        onHide={close}>
            {children}
        </Dialog>  
        );
    };

export default ModalContainer;